import { getUrlParams } from './getUrlParams'
import { setTurboCookie, getCookieValue } from '@turbodebt/turbo-shared'
import { pageview, event } from './ga4'

export function initAbandonModal(
  configuration = {
    element_id: 'savingsEstimatesPopup',
    cookie_name: 'savingsEstimatesModalShown',
    modal_button_id: 'sePopupButton',
    requiresURLParam: true,
    session_key: 'savings-left-via-click',
    thresholdInSeconds: 30,
    check_for_onLeave: () => {
      return true
    },
    modal_display_callback: () => {
      return true
    },
    modal_close_callback: () => {
      return true
    },
  },
) {
  const {
    element_id,
    cookie_name,
    modal_button_id,
    requiresURLParam,
    session_key,
    thresholdInSeconds,
    check_for_onLeave,
    modal_display_callback,
    modal_close_callback,
  } = configuration
  // abandonment modal
  const modal = /** @type {HTMLDialogElement} */ (
    document.getElementById(element_id)
  )
  const modalClose = document.getElementById('popupClose')
  const modalButton = document.getElementById(modal_button_id)
  const MODAL_COOKIE_NAME = cookie_name
  const MODAL_COOKIE_HOURS = 7 * 24 // 7 days
  const MODAL_SHOW_TIMEOUT = thresholdInSeconds * 1000
  let modalDisplayedThisSession = false
  const getParams = getUrlParams(window.location.search) || {}
  const queryParamForModal = requiresURLParam
    ? getParams?.showModal === 'true'
    : true

  function shouldShowModal() {
    if (!modal) {
      console.warn('missing dialog/modal element')
      return
    }
    if (modalDisplayedThisSession) {
      console.warn('modal already displayed this session')
      return
    }
    if (isClosedCookieSet()) {
      console.warn('closed cookie set to true')
      return
    }
    if (!queryParamForModal) return // for AB test

    try {
      if (typeof modal.showModal === 'function') {
        modal.showModal()
        modal_display_callback()
        event({
          action: 'chat_pop_view',
          params: {},
        })
        pageview('chat-pop-view')
      }
      modalDisplayedThisSession = true
    } catch {
      // nothing
    }
  }

  function isClosedCookieSet() {
    const cookieSet = getCookieValue(MODAL_COOKIE_NAME)
    return cookieSet && cookieSet.length > 1
  }

  function setClosedCookie() {
    setTurboCookie(MODAL_COOKIE_NAME, { 1: 1 }, { expires: MODAL_COOKIE_HOURS })
  }

  if (modalClose) {
    modalClose.addEventListener('click', function () {
      if (modal && typeof modal.close === 'function') {
        modal.close()
      }
    })
  }

  modal.addEventListener('close', function () {
    setClosedCookie()
    modal_close_callback()
  })

  // idle detection
  /**
   * @type {string | number | NodeJS.Timeout | null | undefined}
   */
  let idleTimer = null
  function resetIdleTimer() {
    if (idleTimer) clearTimeout(idleTimer)
    if (isClosedCookieSet() || modalDisplayedThisSession) return
    idleTimer = setTimeout(() => {
      shouldShowModal()
    }, MODAL_SHOW_TIMEOUT)
  }

  ;[
    'mousemove',
    'keydown',
    'scroll',
    'touchstart',
    'touchmove',
    'pointermove',
  ].forEach((ev) =>
    window.addEventListener(ev, resetIdleTimer, { passive: true }),
  )
  // start the idle timer
  resetIdleTimer()

  // navigated back to savings-estimates from button click
  window.addEventListener('pageshow', (e) => {
    const leftViaClick = sessionStorage.getItem(session_key)
    if (isClosedCookieSet()) return
    if (!leftViaClick) return

    // detect back/forward navigation
    const navEntries =
      performance.getEntriesByType && performance.getEntriesByType('navigation')
    const navType =
      // @ts-ignore - ignoring .type not exist on PerformanceEntry
      navEntries && navEntries[0] && navEntries[0].type
        ? // @ts-ignore - ignoring type not exist on PerformanceEntry
          navEntries[0].type
        : // fallback for older browsers
          performance.navigation && performance.navigation.type === 2
          ? 'back_forward'
          : ''

    if (e.persisted || navType === 'back_forward') {
      shouldShowModal()
      sessionStorage.removeItem(session_key)
    }
  })

  // desktop: exit intent
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY < 0 && check_for_onLeave()) {
      if (isClosedCookieSet()) return
      shouldShowModal()
    }
  })

  // mobile: exit intent
  window.addEventListener('popstate', function () {
    if (isClosedCookieSet()) return
    shouldShowModal()
  })

  if (modalButton) {
    modalButton.addEventListener('click', function () {
      pageview('chat-pop-click')
      event({
        action: 'chat_pop_click',
        params: {},
      })
      setClosedCookie()
    })
  }
}
